import { ActionButton, useFormContainerContext } from '@if/mui'
import { useTranslation } from 'react-i18next'

// Reset action shown beside the page-action submit button: reverts the form to its initial values.
const WorksheetResetAction = () => {
  const { t } = useTranslation()
  const { methods } = useFormContainerContext()

  return (
    <ActionButton type="button" emphasis="normal" onClick={() => methods.reset()}>
      {t('common.reset')}
    </ActionButton>
  )
}

export default WorksheetResetAction
